export const publishableKey = "pk_test_sx2vO1mVBZgepNL1IYlptOIE00PaqPqWle";
